import { render, staticRenderFns } from "./CardOrgApplication.vue?vue&type=template&id=a96856aa"
import script from "./CardOrgApplication.vue?vue&type=script&lang=js"
export * from "./CardOrgApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports